import React, { useContext } from 'react';
import SearchBar from './SearchBar';
import FilterButton from './FilterButton';
import SettingsButton from './SettingsButton';
import AppliedFilters from './AppliedFilters';
import CategoryRelevancyTable from './CategoryRelevancyTable';
import { CategoryRelevancyContext } from '../contexts/CategoryRelevancyContext';
import { useMenuControl } from '../hooks/useMenuControl';
import { WarningIcon } from 'assests/GmsIcons';

const CuratedCategoryRelevancyTable: React.FC = () => {
    const {
        masterCategories,
        masterCategoryTypes,
        rowDensity,
        openMenu,

        curatedCategories,
        curatedExpandedCategories,
        curatedCoSoldCategories,
        curatedFilters,
        curatedSearchTerm,
        curatedSortBy,
        curatedSortOrder,
        curatedLoadingCategories,
        isCuratedCoSoldCategoryLoading: isCuratedCategoryLoading,
        handleCuratedCategoryExpand,
        handleCuratedSearch,
        handleCuratedFilterChange,
        handleCuratedRemoveFilter,
        handleCuratedSort,

        handleToggleCuration,
        handleRowDensityChange,
    } = useContext(CategoryRelevancyContext);

    const { toggleMenu, filterRef, settingsRef } = useMenuControl();

    return (
        <section aria-labelledby="curated-category-relevancy-title" className='tw-px-4 tw-pt-2'>
            <div className="tw-mb-2 tw-box-border tw-w-auto tw-border-t-[1px] tw-border-solid tw-border-lightgray-200" />
            <div className="tw-h-7 tw-bg-[#fffae6] tw-mb-4 tw-border tw-border-[#ffc400] tw-flex tw-items-center tw-px-4 tw-py-1"><WarningIcon /><p className="tw-ml-2">Note: Relevant categories are configured in Category Relevancy module</p></div>
            <div className="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-mb-4 tw-gap-y-3">
                <SearchBar value={curatedSearchTerm} onChange={handleCuratedSearch} />

                <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-3">
                    <div ref={filterRef}>
                        <FilterButton
                            filters={curatedFilters}
                            onFilterChange={handleCuratedFilterChange}
                            categories={masterCategories}
                            categoryTypes={masterCategoryTypes}
                            isOpen={openMenu === 'filter'}
                            onToggle={() => toggleMenu('filter')}
                            activeTab={'curated'}
                        />
                    </div>

                    <div ref={settingsRef}>
                        <SettingsButton
                            onRowDensityChange={handleRowDensityChange}
                            isOpen={openMenu === 'settings'}
                            onToggle={() => toggleMenu('settings')}
                            currentDensity={rowDensity}
                        />
                    </div>
                </div>
            </div>

            <AppliedFilters
                filters={curatedFilters}
                onRemoveFilter={handleCuratedRemoveFilter}
            />

            <CategoryRelevancyTable
                categories={curatedCategories}
                expandedCategories={curatedExpandedCategories}
                coSoldCategories={curatedCoSoldCategories}
                onCategoryExpand={handleCuratedCategoryExpand}
                onToggleCuration={handleToggleCuration}
                isCuratedTab={true}
                rowDensity={rowDensity}
                loadingCategories={curatedLoadingCategories}
                loadingCoSoldCategories={isCuratedCategoryLoading}
                handleSort={handleCuratedSort}
                sortBy={curatedSortBy}
                sortOrder={curatedSortOrder}
            />
        </section>
    );
};

export default CuratedCategoryRelevancyTable;